export const SHOW_CHAT_MODAL = 'SHOW_CHAT_MODAL';
export const HIDE_CHAT_MODAL = 'HIDE_CHAT_MODAL';
export const TOGGLE_CHAT_MODAL = 'TOGGLE_CHAT_MODAL';

export const SET_ACTIVE_CHAT_SUCCESS = 'SET_ACTIVE_CHAT_SUCCESS';
export const UPDATE_ACTIVE_CHAT_SUCCESS = 'UPDATE_ACTIVE_CHAT_SUCCESS';

export const SET_CHAT_CONTENT = 'SET_CHAT_CONTENT';
